// extracted by mini-css-extract-plugin
module.exports = {"link":"Mobile_link__QzaAa"};